import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/client-layout.tsx");
